import React from 'react';
import { FormControl } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';

import { StyledDatePicker } from 'components/Input/styles';

import { colors } from 'theme/colors';

import { TZ_FREE_DATE_FORMAT, tzFreeAnswer } from '../utils';
import { ProtectorTypeDateProps } from '../types';
import CustomActionBar from '../CustomPickerActionBar/CustomPickerActionBar';

dayjs.extend(utc);

export const CustomDatePicker = ({
  value,
  onChange,
  requiredNotFilled,
  errorMessage,
  noFutureDate,
  tzFree,
  today,
  testId,
  ...props
}: ProtectorTypeDateProps): React.ReactElement => {
  const [val, setValue] = React.useState<Dayjs | null>(() => {
    if (!value) {
      return null;
    }
    return tzFree && typeof value === 'string' ? dayjs.utc(value) : dayjs(value as string);
  });

  const handleChange = (newValue: Dayjs | null): void => {
    if (newValue && Object.prototype.toString.call(newValue) === '[object Object]') {
      if (Number.isNaN(newValue)) {
        return;
      }
      setValue(newValue);
      onChange(tzFreeAnswer(newValue, TZ_FREE_DATE_FORMAT, tzFree));
    } else {
      setValue(null);
      onChange(null);
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <FormControl fullWidth data-testid={testId}>
      <StyledDatePicker
        {...props}
        utc
        timezone="UTC"
        id="date-picker"
        value={val}
        maxDate={noFutureDate ? (today ? dayjs.utc(today) : dayjs()) : undefined}
        // @ts-ignore
        onChange={(date: Dayjs) => {
          handleChange(date);
        }}
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        slotProps={{
          field: { clearable: true },
          textField: {
            size: props.size || 'small',
            helperText: errorMessage,
            InputProps: {
              ...(window.innerWidth < 768 && {
                endAdornment: <InsertInvitationIcon htmlColor={colors.text.secondary} />,
              }),
            },
            error: requiredNotFilled,
          },
          clearButton: {
            style: { padding: 0 },
          },
        }}
        slots={{
          actionBar: () => <CustomActionBar actions={['accept']} onAccept={() => handleClose()} />,
          toolbar: () => null,
        }}
        format="DD/MM/YYYY"
      />
    </FormControl>
  );
};

export default CustomDatePicker;
